// extracted by mini-css-extract-plugin
export default {"titleWrapper":"HeaderImage-module-titleWrapper"};